import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'experience-overview-tab-2-part',
	standalone: true,
	templateUrl: './experience-overview-tab-2.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./experience-overview-tab-2.part.scss`],
})
export class ExperienceOverviewTab2Part {
}
